import {
  BILLING_ADDRESS_ERROR,
  SHIPPING_ADDRESS_ERROR,
  SHIPPING_METHOD_ERROR,
  PAYMENT_ERROR,
  CARD_TOKEN_ERROR,
  CARD_TOKENIZATION_ERROR,
  GIFT_CARD_ONLY_PAYMENT_ERROR,
  PAYMENT_DATA_NOT_COMPLETE_ERROR,
  ZIP_ERROR,
  SHIPPING_ADDRESS_UNEXPECTED_ERROR,
  BILLING_ADDRESS_UNEXPECTED_ERROR,
  PAYMENT_ERROR_DECLINED_GIFT_CARD,
  SHIPPING_ADDRESS_STATE_NOT_ALLOWED,
  ITEMS_NOT_DELIVERABLE_ERROR,
  ITEMS_NOT_DELIVERABLE_CART_ERROR,
  PAYMENT_SESSION_AUTHORIZATION_ERROR,
  SHIPPING_ADDRESS_INVALID_PO_BOX,
  TRUEMED_PAYMENT_ERROR,
} from '../../blocks/Checkout/SteppedCheckout/constants';
import messages from '../../blocks/Checkout/messages';

const getCheckoutErrorMessage = (errorCode) => {
  switch (errorCode) {
    case SHIPPING_ADDRESS_ERROR:
      return messages.noShippingAddress;
    case BILLING_ADDRESS_ERROR:
      return messages.noBillingAddress;
    case SHIPPING_METHOD_ERROR:
      return messages.noShippingMethods;
    case PAYMENT_ERROR:
    case PAYMENT_SESSION_AUTHORIZATION_ERROR:
    case CARD_TOKEN_ERROR:
      return messages.paymentError;
    case CARD_TOKENIZATION_ERROR:
      return messages.cardTokenizationError;
    case PAYMENT_DATA_NOT_COMPLETE_ERROR:
      return messages.paymentDataMissingError;
    case ZIP_ERROR:
      return messages.zipInvalidError;
    case GIFT_CARD_ONLY_PAYMENT_ERROR:
      return messages.giftCardOnlyPaymentError;
    case SHIPPING_ADDRESS_INVALID_PO_BOX:
      return messages.poBoxAddressError;
    case SHIPPING_ADDRESS_UNEXPECTED_ERROR:
      return messages.addressUnexpectedError;
    case BILLING_ADDRESS_UNEXPECTED_ERROR:
      return messages.billingAddressUnexpectedError;
    case PAYMENT_ERROR_DECLINED_GIFT_CARD:
      return messages.giftCardDeclinedPaymentError;
    case SHIPPING_ADDRESS_STATE_NOT_ALLOWED:
      return messages.shippingAddressStateNotAllowed;
    case ITEMS_NOT_DELIVERABLE_ERROR:
    case ITEMS_NOT_DELIVERABLE_CART_ERROR:
      return messages.itemNotDeliverableError;
    case TRUEMED_PAYMENT_ERROR:
      return messages.truemedPaymentError;
    default:
      return messages.defaultErrorMessage;
  }
};

export default getCheckoutErrorMessage;
